module.exports = __webpack_public_path__ + "static/media/programme_slogan_en.b9d36e15.png";